module.exports = __webpack_public_path__ + "static/media/ic-icon-auto.17c680f6.svg";